import React from 'react'

import {
  ConfirmationModal,
  CurrencyInput,
  Ink,
  ModalActionTypes,
  Spinner,
} from '@acorns/web-components'

import Button from 'components/Button'
import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { TestIDs } from 'test/utils/testIds'

import {
  ButtonsContainer,
  Container,
  Link2,
  PresetValue2,
  PresetValuesContainer2,
  Subtitle,
  Title,
} from '../../styled-components'
import { InnerProps } from '../../types'
import enhance, { RECURRING_AMOUNTS_LATER, investmentAmount } from './enhance'

/* istanbul ignore next */
const NO_OP = () => null

export const Page: React.SFC<InnerProps> = props => (
  <>
    <Nav />
    <Layout>
      <Container>
        {props.loading ? (
          <Spinner />
        ) : (
          <>
            <Title data-testid={TestIDs.START_INVESTING.LATER_RECURRING_TITLE}>
              {props.header}
            </Title>
            <Subtitle data-testid={TestIDs.START_INVESTING.RECURRING_SUBTITLE}>
              {props.text}
            </Subtitle>
            <CurrencyInput
              value={investmentAmount(props)}
              onChange={NO_OP}
              helperText={'Every week into Acorns Later'}
              readOnly
            />
            <PresetValuesContainer2 selectedIndex={0}>
              {RECURRING_AMOUNTS_LATER.map((amount, i) => (
                <PresetValue2
                  selectedIndex={props.investmentMode}
                  onClick={props.handleRecurringAmountChange}
                  key={i}
                  data-value={amount}
                >
                  <>
                    {`$${amount}`}
                    <Ink opacity={0.02} />
                  </>
                </PresetValue2>
              ))}
            </PresetValuesContainer2>

            <Separator extraMargin />
            <ButtonsContainer>
              <Button
                onPress={props.handleCTA}
                data-testid={TestIDs.START_INVESTING.SUBMIT_CTA}
                disabled={
                  props.submitting || props.noFundingSourceModalOpen || props.confirmModalOpen
                }
              >
                {props.submitting ? (
                  <Spinner height={20} width={20} white={true} />
                ) : (
                  'Start Investing'
                )}
              </Button>
              <Link2
                onClick={props.handleSkip}
                data-testid={TestIDs.START_INVESTING.MAKE_ONE_TIME_BUTTON}
              >
                Make a one-time contribution instead?
              </Link2>
            </ButtonsContainer>
          </>
        )}
      </Container>

      <ConfirmationModal
        isOpen={props.confirmModalOpen}
        title={'Recurring Investment'}
        actions={[
          {
            label: 'Cancel',
            type: ModalActionTypes.secondary,
            handler: props.handleModalClosed,
          },
          {
            label: 'OK',
            type: ModalActionTypes.primary,
            handler: props.handleModalConfirmed,
          },
        ]}
        message={`$${investmentAmount(
          props,
        )} will be transferred from your funding source to your acorns account weekly, starting this week. You can change this anytime.`}
      />
      <ConfirmationModal
        isOpen={props.noFundingSourceModalOpen}
        message={'Please link a funding source'}
        actions={[
          {
            label: 'Skip',
            type: ModalActionTypes.secondary,
            handler: props.handleSkip,
          },
          {
            label: 'Link Bank',
            type: ModalActionTypes.primary,
            handler: props.handleLinkAccount,
          },
        ]}
      />
    </Layout>
  </>
)

export default enhance(Page)
